import LoaderDots from './LoaderDots';

export default LoaderDots;
